import { string } from "zod";

export enum AccountConfigFlags {
	VolksUptime = "volksUptime",
	PresentationAccountIds = "presentationAccountIds",
	BenchTest = "benchTest",
	AcceptanceTest = "acceptanceTest",
	BrLoghis = "brLoghis",
	Dn = "dn",
}

export enum SelectHealthHistory {
	indexSelect = 0,
}

export const SelectHealthHistoryIndex: Record<SelectHealthHistory, number> = {
	[SelectHealthHistory.indexSelect]: 0,
};

export class HealthManager {
	private static _lastIndex: number = SelectHealthHistory.indexSelect;

	static saveLastIndex(newIndex: number) {
		this._lastIndex = newIndex;
	}

	static getLastIndex(): number {
		return this._lastIndex;
	}
}
